import { Skeleton } from '../ui/skeleton'

export function LoadingGroupedActivity() {
  return (
    <div className='flex flex-col -mx-4'>
      {Array(3)
        .fill(null)
        .map((_, j) => (
          <div
            key={`row-item-skeleton-${j}`}
            className='flex items-center gap-4 justify-between px-4 py-3'
          >
            <div className='flex items-center gap-4'>
              <Skeleton
                className='size-10 rounded-full'
                delay={`${j * 100}ms`}
              />
              <div className='flex flex-col gap-2.5'>
                <Skeleton className='w-24 h-4' delay={`${j * 200}ms`} />
                <Skeleton className='w-16 h-3' delay={`${j * 300}ms`} />
              </div>
            </div>
            <div className='flex flex-col items-end gap-2.5'>
              <Skeleton className='w-24 h-4' delay={`${j * 200}ms`} />
              <Skeleton className='w-16 h-3' delay={`${j * 300}ms`} />
            </div>
          </div>
        ))}
    </div>
  )
}
